import { formatOneDigitNumber, weightAverageByMileage, withUnit } from '@utils/formatters';
import { ReactNode } from 'react';
import { compose } from 'redux';

import { KILOMETERS_PER_HOUR } from '../constants/units';
import createColumn from './createColumn';

export const speedSignal = {
    unit: KILOMETERS_PER_HOUR,
    displayedUnit: KILOMETERS_PER_HOUR,
    format: compose<ReactNode>(withUnit(KILOMETERS_PER_HOUR), formatOneDigitNumber),
    average: weightAverageByMileage,
};

export const averageSpeed = createColumn({
    key: 'averageSpeed',
    dataField: 'averageSpeed',
    labelId: 'averageSpeed',
    formatter: speedSignal.format,
    unit: speedSignal.unit,
});
